module.exports = __webpack_public_path__ + "media/images/app/homepage/couture/vca-8db63c8fd123a55b02db24c6bd8d3329.webp";